import { Route, Routes } from 'react-router-dom';
import AuthenticationGuard from 'components/common/auth/AuthenticationGuard';
import AmendAddressPage from 'components/common/policyholderinfo/AmendAddressPage';
import AmendBankDetailsPage from 'components/sitePages/bankDetails/AmendBankDetails';
import AmendEmailAddressPage from 'components/common/policyholderinfo/AmendEmailAddressPage';
import AmendPersonalDetailsPage from 'components/common/policyholderinfo/AmendPersonalDetailsPage';
import ClaimDetailsPage from 'components/common/policyholderinfo/ClaimDetailsPage';
import ClaimDocuments from 'components/common/policyholderinfo/ClaimDocuments';
import ClaimNextStepsPage from 'components/common/policyholderinfo/ClaimNextStepsPage';
import AddBankDetailsPage from 'components/sitePages/bankDetails/AddBankDetailsPage';
import GapClaimSummary from 'components/common/policyholderinfo/GapClaimSummary';
import PersonalDetailsPage from 'components/common/policyholderinfo/PersonalDetailsPage';
import RepaymentSetupPage from 'components/sitePages/bankDetails/RepaymentSetupPage';
import MissedPayment from 'components/payment/missedPayment/MissedPaymentPage';
import MissedPaymentSuccessPage from 'components/payment/missedPayment/MissedPaymentSuccessPage';
import PaymentPage from 'components/payment/singlePayment/PaymentPage';
import AlloyRepairRequestManager from 'components/sitePages/alloyRepairRequest/AlloyRepairRequestManager';
import ConfirmationPage from 'components/sitePages/ConfirmationPage';
import CosmeticRepairRequestManager from 'components/sitePages/cosmeticRepairRequest/CosmeticRepairRequestManager';
import ClaimDocumentsPage from 'components/sitePages/documents/ClaimDocumentsPage';
import ViewDocumentPage from 'components/sitePages/documents/ViewDocumentPage';
import GeneralErrorPage from 'components/sitePages/generalError/GeneralErrorPage';
import HomePage from 'components/sitePages/HomePage';
import LandingPage from 'components/sitePages/landingPage/LandingPage';
import ProductPage from 'components/sitePages/product/ProductPage';
import RedirectAuthPage from 'components/sitePages/RedirectAuthPage';
import ExistingRepairPage from 'components/sitePages/repair/ExistingRepairPage';
import RepairRequestError from 'components/sitePages/RepairRequestError';
import RepairRequestPreCheckPage from 'components/sitePages/RepairRequestPreCheckPage';
import TyreRepairRequestManager from 'components/sitePages/tyreRepairRequest/TyreRepairRequestManager';
import VerifyEmailPage from 'components/sitePages/VerifyEmailPage';
import ClaimProvider from 'context/ClaimProvider';
import { MissedPaymentsPaths, PayPaths, RoutePaths } from 'Constants/Common';
import Layout from 'components/Layout';

export const AppRouter = () => {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route
                    path={RoutePaths.LandingPage}
                    element={<LandingPage />}
                />
                <Route
                    path={RoutePaths.Redirect}
                    element={<RedirectAuthPage />}
                />
                <Route path={RoutePaths.Verify} element={<VerifyEmailPage />} />
                <Route
                    path={RoutePaths.Home}
                    element={
                        <AuthenticationGuard
                            component={HomePage}
                            path={RoutePaths.Home}
                        />
                    }
                />
                <Route
                    path={RoutePaths.Product}
                    element={
                        <AuthenticationGuard
                            component={ProductPage}
                            path={RoutePaths.Product}
                        />
                    }
                />
                <Route
                    path={RoutePaths.ViewRequests}
                    element={
                        <AuthenticationGuard
                            component={ExistingRepairPage}
                            path={RoutePaths.ViewRequests}
                        />
                    }
                />
                <Route
                    path={RoutePaths.Alloy}
                    element={
                        <AuthenticationGuard
                            component={AlloyRepairRequestManager}
                            path={RoutePaths.Alloy}
                        />
                    }
                />
                <Route
                    path={RoutePaths.Cosmetic}
                    element={
                        <AuthenticationGuard
                            component={CosmeticRepairRequestManager}
                            path={RoutePaths.Cosmetic}
                        />
                    }
                />
                <Route
                    path={RoutePaths.Tyre}
                    element={
                        <AuthenticationGuard
                            component={TyreRepairRequestManager}
                            path={RoutePaths.Tyre}
                        />
                    }
                />
                <Route
                    path={RoutePaths.ConfirmationError}
                    element={
                        <AuthenticationGuard
                            component={RepairRequestError}
                            path={RoutePaths.ConfirmationError}
                        />
                    }
                />
                <Route
                    path={RoutePaths.Confirmation}
                    element={
                        <AuthenticationGuard
                            component={ConfirmationPage}
                            path={RoutePaths.Confirmation}
                        />
                    }
                />
                <Route
                    path={RoutePaths.GeneralError}
                    element={<GeneralErrorPage />}
                />
                <Route
                    path={RoutePaths.PersonalDetails}
                    element={<PersonalDetailsPage />}
                />
                <Route
                    path={RoutePaths.AmendPersonalDetails}
                    element={<AmendPersonalDetailsPage />}
                />
                <Route
                    path={RoutePaths.AmendAddressDetails}
                    element={<AmendAddressPage />}
                />
                <Route
                    path={RoutePaths.AmendEmailAddress}
                    element={<AmendEmailAddressPage />}
                />
                <Route
                    path={RoutePaths.AmendBankDetails}
                    element={<AmendBankDetailsPage />}
                />
                <Route
                    path={RoutePaths.AddBankDetails}
                    element={<AddBankDetailsPage />}
                />
                <Route
                    path={RoutePaths.RepaymentSetup}
                    element={<RepaymentSetupPage />}
                />
                <Route path={MissedPaymentsPaths.Root}>
                    <Route index element={<LandingPage />} />
                    <Route
                        path={MissedPaymentsPaths.MissedPayment}
                        element={<MissedPayment />}
                    />
                    <Route
                        path={`${MissedPaymentsPaths.MissedPayment}/${MissedPaymentsPaths.Success}`}
                        element={<MissedPaymentSuccessPage />}
                    />
                </Route>
                <Route path={PayPaths.Root}>
                    <Route index element={<LandingPage />} />
                    <Route path={PayPaths.Payment} element={<PaymentPage />} />
                </Route>
                <Route
                    path={RoutePaths.ViewDocuments}
                    element={<ViewDocumentPage />}
                />
                <Route
                    path={RoutePaths.ClaimDocuments}
                    element={<ClaimDocumentsPage />}
                />
                <Route
                    path={RoutePaths.ClaimDetails}
                    element={
                        <ClaimProvider>
                            <ClaimDetailsPage />
                        </ClaimProvider>
                    }
                />
                <Route
                    path={RoutePaths.ClaimSummary}
                    element={
                        <ClaimProvider>
                            <GapClaimSummary />
                        </ClaimProvider>
                    }
                />
                <Route
                    path={RoutePaths.ClaimNextSteps}
                    element={
                        <ClaimProvider>
                            <ClaimNextStepsPage />
                        </ClaimProvider>
                    }
                />
                <Route
                    path={RoutePaths.ClaimUploadDocuments}
                    element={
                        <ClaimProvider>
                            <ClaimDocuments />
                        </ClaimProvider>
                    }
                />
                <Route
                    path={RoutePaths.RepairRequestPreCheckPage}
                    element={
                        <AuthenticationGuard
                            component={RepairRequestPreCheckPage}
                            path={RoutePaths.RepairRequestPreCheckPage}
                        />
                    }
                />
            </Route>
        </Routes>
    );
};
